import { EncryptStorage } from 'encrypt-storage';

// Example of secret_key variable in an .env file
const envVar = `REACT_APP_SECRET_KEY_${process.env.REACT_APP_ENVIRONMENT.toString().toUpperCase()}`;

const encryptStorage = new EncryptStorage(
  process.env[envVar],
  {
    prefix: process.env.REACT_APP_ENVIRONMENT,
    storageType: 'sessionStorage',
  },
);

export default encryptStorage;
